var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fish-tree',{attrs:{"data":_vm.data,"default-checked-keys":['ShortPlan', 'Project-create'],"multiple":""},on:{"item-checked":_vm.itemCheckedHandler}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d341d93","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./examples/components/DemoTreeCheckbox.vue
// module id = 793
// module chunks = 1